module.exports = __webpack_public_path__ + "static/media/food.d4e7eb05.webp";